export function IsRootPathSegment(segment, rootRegExp) {
    return rootRegExp.test(segment);
}
export function IsRelativePathSegment(segment) {
    return ((segment === '.')
        || (segment === '..'));
}
export function IsEntryNamePathSegment(segment, rootRegExp) {
    return !IsRootPathSegment(segment, rootRegExp)
        && !IsRelativePathSegment(segment);
}
export function IsValidPathSegment(segment) {
    return (segment !== '')
        && !(/[<>:"\/\\|?*]/g.test(segment));
}
export function IsValidEntryNamePathSegment(segment, rootRegExp) {
    return IsValidPathSegment(segment)
        && IsEntryNamePathSegment(segment, rootRegExp);
}
export function BaseNamePathSegment(segment, ext = '') {
    return ((ext !== '') && segment.endsWith(ext))
        ? segment.slice(0, -ext.length)
        : segment;
}
export const ALLOWED_SPECIAL_SEGMENTS_NONE = new Set();
export function BaseNamePathSegmentImpure(segment, ext, rootRegExp, allowedSpecialSegments = ALLOWED_SPECIAL_SEGMENTS_NONE) {
    if (IsRelativePathSegment(segment)) {
        return allowedSpecialSegments.has(segment) ? segment : null;
    }
    else if (IsRootPathSegment(segment, rootRegExp)) {
        return allowedSpecialSegments.has('root')
            ? (segment === '') ? '/' : ''
            : null;
    }
    else {
        return BaseNamePathSegment(segment, ext);
    }
}
export function BaseNamePathSegmentToStemAndExtTuple(basename) {
    const segments = basename.split('.');
    if ((segments.length === 1) || (segments[0].length === 0)) {
        return {
            stem: segments[0],
            ext: '',
        };
    }
    else {
        const ext = '.' + segments.pop();
        return {
            stem: segments.join('.'),
            ext: ext,
        };
    }
}
export function BaseNamePathSegmentImpureToStemAndExtTuple(basename, rootRegExp) {
    return IsEntryNamePathSegment(basename, rootRegExp)
        ? BaseNamePathSegmentToStemAndExtTuple(basename)
        : null;
}
//# sourceMappingURL=segment.js.map